<template>
  <v-container>
    <v-row justify="space-between">
      <v-col cols="8" sm="10">
        <span class="font-weight-light" style="font-size: 16pt">{{ $t('label.openAuctions') }}</span>
      </v-col>
    </v-row>

    <v-row justify="start" v-if="showSkeletonLoader">
      <v-col cols="6" lg="3" v-for="n in 4" :key="n">
        <v-skeleton-loader class="mx-auto" max-width="400" type="card"></v-skeleton-loader>
      </v-col>
    </v-row>

    <v-row justify="start" v-if="auctions.length">
      <v-col cols="12" sm="6" md="4" lg="3" xl="2" v-for="(item, i) in auctions" :key="i">
        <auction-card :auction="item" @itemSelected="itemSelected"></auction-card>
      </v-col>
    </v-row>

    <v-row v-else justify="center">
      <h3 v-show="!showSkeletonLoader">{{ $t('message.info.noAuctionsToShow') }}</h3>
    </v-row>

    <v-dialog v-model="isAuctionDetailDialogOpen" max-width="1200" persistent>
      <auction-detail :auctionId="auctionSelected.id" :isActive="isAuctionDetailDialogOpen" @close="isAuctionDetailDialogOpen = false"></auction-detail>
    </v-dialog>

    <v-dialog v-model="isAuctionBidDialogOpen" max-width="600" persistent>
      <auction-bid :auctionId="auctionSelected.id" :isActive="isAuctionBidDialogOpen" @cancel="closeAuctionBidDialog" @saved="auctionBidSaved"></auction-bid>
    </v-dialog>

   <v-dialog v-model="isAuctionChatDialogOpen" max-width="1000" persistent>
      <auction-chat :auctionId="auctionSelected.id" :isActive="isAuctionChatDialogOpen" @close="closeChatDialog"></auction-chat>
    </v-dialog>
  </v-container>
</template>

<script>
import { showMessage } from '../../mixins'
import status from '../../core/Auctions/status'
import AuctionBid from '../../components/Auctions/auctions/AuctionBid'
import AuctionCard from '../../components/Auctions/auctions/AuctionCard'
import AuctionChat from '../../components/Auctions/auctions/AuctionChat'
import AuctionDetail from '../../components/Auctions/auctions/AuctionDetail'

export default {
  name: 'OpenAuctionsPage',
  components: { AuctionCard, AuctionDetail, AuctionBid, AuctionChat },
  mixins: [showMessage],
  data: () => ({
    auctions: [],
    showSkeletonLoader: true,
    auctionSelected: {},
    isAuctionDetailDialogOpen: false,
    isAuctionBidDialogOpen: false,
    isAuctionChatDialogOpen: false
  }),
  methods: {
    getOpenAuctions () {
      this.showSkeletonLoader = true
      this.$proxy.get(`api/auctions?statusIds=${status.OPEN}`)
        .then((r) => {
          r.data = r.data.filter(a => a.statusId !== status.EXPIRED)

          r.data = r.data.sort((a, b) => {
            return (a.startDateTime < b.startDateTime) ? -1 : 1
          })
          this.auctions = r.data
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.showSkeletonLoader = false
        })
    },
    itemSelected (auction, action) {
      this.auctionSelected = Object.assign({}, auction)
      switch (action) {
        case 'detail':
          this.isAuctionDetailDialogOpen = true
          break
        case 'bid':
          this.isAuctionBidDialogOpen = true
          break
        case 'chat':
          this.isAuctionChatDialogOpen = true
          break
      }
    },
    auctionBidSaved () {
      this.isAuctionBidDialogOpen = false
      this.auctions = []
      this.auctionSelected = {}
      this.getOpenAuctions()
    },
    closeAuctionBidDialog () {
      this.isAuctionBidDialogOpen = false
      this.auctionSelected = {}
    },
    closeChatDialog () {
      this.isAuctionChatDialogOpen = false
      this.auctionSelected = {}
    }
  },
  mounted () {
    this.getOpenAuctions()
  }
}
</script>

<style>

</style>
